window.onload = function(){ 
    document.querySelectorAll('.discount-button').forEach(e => { 
        e.addEventListener('click', function() {
            window._klOnsite = window._klOnsite || []; 
            window._klOnsite.push(['openForm', 'VhF4YL']);
        });
    });
    
    
    // all reviews
    // const elem = document.querySelectorAll(".spr-summary.rte .spr-summary-caption");
    // if (elem.length > 0) {
    //     elem.forEach(e => {
    //         if (e.innerHTML && e.innerHTML.trim() !== '') 
    //         {
    //             console.log(e.parentElement.parentElement.parentElement.parentElement.parentElement);
    //         }
    //     });
    // }
}